import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LendingTeamComponent } from './lending-team/lending-team.component';
import { RouterModule } from '@angular/router';
import { appRoutes } from '../app.routes';
import { ProductsComponent } from './products/products.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@NgModule({
  declarations: [LendingTeamComponent, ProductsComponent],
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes),
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    LendingTeamComponent,
  ]
})
export class LendingModule { }
